import { FC, useEffect, useRef, useState } from "react";
import { TrialPeriodProps } from "./trial-period.types";
import {
  Divider,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { PickerValue } from "@mui/x-date-pickers/internals";
import dayjs from "dayjs";

const TrialPeriod: FC<TrialPeriodProps> = ({ onChange }) => {
  const [trialType, setTrialType] = useState("");
  const [endDate, setEndDate] = useState<PickerValue>(null);
  const [infiniteTrialSelected, setInfiniteTrialSelected] = useState(false);

  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    onChange(endDate?.toISOString(), infiniteTrialSelected);
  }, [endDate, infiniteTrialSelected]);

  return (
    <Stack>
      <FormControl fullWidth>
        <InputLabel>Period</InputLabel>
        <Select
          value={trialType}
          label="Trial Type"
          onChange={({ target: { value } }) => {
            setTrialType(value);
            const today = dayjs();

            switch (value) {
              case "day":
                setEndDate(today.add(1, "day").endOf("day"));
                break;
              case "week":
                setEndDate(today.add(1, "week").endOf("day"));
                break;
              case "month":
                setEndDate(today.add(1, "month").endOf("day"));
                break;
              case "year":
                setEndDate(today.add(1, "year").endOf("day"));
                break;
              case "always":
                setEndDate(null);
                setInfiniteTrialSelected(true);
                break;
              case "custom":
                setEndDate(null);
                setInfiniteTrialSelected(false);
                break;
              default:
                setEndDate(null);
            }
          }}
        >
          <MenuItem value="day">Day</MenuItem>
          <MenuItem value="week">Week</MenuItem>
          <MenuItem value="month">Month</MenuItem>
          <MenuItem value="year">Year</MenuItem>
          <MenuItem value="always">Always</MenuItem>
          <MenuItem value="custom">Custom</MenuItem>
        </Select>
      </FormControl>

      {trialType === "custom" && (
        <Stack>
          <Divider sx={{ margin: "8px 0" }}>To</Divider>
          <DatePicker
            label="End date"
            value={endDate}
            onChange={(value) => value && setEndDate(value.endOf("day"))}
            disablePast
          />
        </Stack>
      )}
    </Stack>
  );
};

export { TrialPeriod };
